<!-- 设备参数设置 -->
<template>
  <el-dialog v-bind="$attrs" v-on="$listeners" :close-on-click-modal="false">
    <el-table stripe size="small" :data="records" :border="true" v-loading="loading" height="60vh">
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column prop="paramName" label="参数名称" width="250"></el-table-column>
      <el-table-column prop="address" label="寄存器地址" width="100" align="center"></el-table-column>
      <el-table-column prop="paramValue" label="参数值" align="center" width="180" v-slot="{row}">
        <el-switch v-model="row.paramValue" :active-value="1" :inactive-value="0" v-if="row.type==='bit'"></el-switch>
        <el-input-number v-model="row.paramValue" :min="row.min" :max="row.max" style="width:130px" v-else></el-input-number>
      </el-table-column>
      <el-table-column prop="unit" label="单位" align="center" width="60"></el-table-column>
      <el-table-column prop="remark" label="参数说明" min-width="200"></el-table-column>
      <el-table-column prop="action" label="操作" width="90" align="center" fixed="right" v-slot="{row}">
        <el-button type="text" title="设置参数" @click="setParam(row)">设置</el-button>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <el-button type="default" @click="close">取消</el-button>
    </template>
  </el-dialog>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";
import SessionStore from "@/utils/SessionStore";

export default {
  extends: BaseVue,
  props: {
    deviceCode: {
      required: true
    }
  },
  data() {
    return {
      status: null,
      records: []
    }
  },
  created() {
    // 弹窗层兜底：仅系统管理员、单位管理员可配置（对齐 acc-app）
    if (!SessionStore.canSettingDeviceParams()) {
      this.$message.warning("仅系统管理员或单位管理员可配置设备参数");
      this.$emit("close");
      return;
    }
    // 批量时取第一台设备参数值作为模板（与传统参数设置一致）
    const primaryCode = (this.deviceCode || "").split(",")[0].trim();
    this.postForm("/device-status/currentStatus", {
      deviceCode: primaryCode
    }).then(dr => {
      this.status = dr.bean;
      this.records = [{
        address: 135,
        type: 'float',
        paramName: "出风口温度设置",
        paramValue: this.status.outWindTempSet,
        unit: "℃",
        min: -40,
        max: 40,
        remark: ""
      },{
        address: 94,
        type: 'short',
        paramName: "新风/空调切换时间间隔",
        paramValue: this.status.minSwitchMinute,
        unit: "分钟",
        min: 0,
        max: 100,
        remark: ""
      },{
        address: 90,
        type: 'short',
        paramName: "滤网电机执行时间",
        paramValue: this.status.motorRunSecond,
        unit: "秒",
        min: 0,
        max: 50,
        remark: ""
      },{
        address: 127,
        type: 'float',
        paramName: "滤网压差上限设置",
        paramValue: this.status.maxNetPressure,
        unit: "kPa",
        min: 0,
        max: 5000,
        remark: ""
      },{
        address: 3,
        bit: 0,
        type: 'bit',
        paramName: "定时器开启",
        paramValue: this.status.allowCron ? 1 : 0,
        unit: "",
        inactiveValue: 0,
        activeValue: 1,
        remark: "0-不开启，1-开启"
      },{
        address: 151,
        type: 'short',
        paramName: "新风机组定时开启",
        paramValue: this.status.systemStartHour,
        unit: "时",
        min: 0,
        max: 23,
        remark: ""
      },{
        address: 152,
        type: 'short',
        paramName: "新风机组定时开启",
        paramValue: this.status.systemStartMinute,
        unit: "分",
        min: 0,
        max: 59,
        remark: ""
      },{
        address: 153,
        type: 'short',
        paramName: "新风机组定时关闭",
        paramValue: this.status.systemStopHour,
        unit: "时",
        min: 0,
        max: 23,
        remark: ""
      },{
        address: 154,
        type: 'short',
        paramName: "新风机组定时关闭",
        paramValue: this.status.systemStopMinute,
        unit: "分",
        min: 0,
        max: 59,
        remark: ""
      },{
        address: 131,
        type: 'float',
        paramName: "室内低温停系统设置值",
        paramValue: this.status.stopFanInTemp,
        unit: "℃",
        min: -40,
        max: 40,
        remark: ""
      },{
        address: 83,
        type: 'short',
        paramName: "室内低温停系统延时",
        paramValue: this.status.fanStopDelayMinute,
        unit: "分钟",
        min: 0,
        max: 40,
        remark: ""
      },{
        address: 145,
        type: 'float',
        paramName: "室内高温开空调设置值",
        paramValue: this.status.startAcInTemp,
        unit: "℃",
        min: -40,
        max: 40,
        remark: ""
      },{
        address: 99,
        type: 'short',
        paramName: "室内高温开空调延时",
        paramValue: this.status.acStartDelayMinute,
        unit: "分钟",
        min: 0,
        max: 40,
        remark: ""
      },{
        address: 129,
        type: 'float',
        paramName: "开启空调室外温度上限",
        paramValue: this.status.startAcOutTemp,
        unit: "℃",
        min: 0,
        max: 40,
        remark: ""
      },{
        address: 92,
        type: 'short',
        paramName: "符合条件开新风模式延时时间设置",
        paramValue: this.status.fanStartDelayMinute,
        unit: "分钟",
        min: 0,
        max: 40,
        remark: ""
      // },{
      //   address: 2,
      //   bit: 7,
      //   type: 'bit',
      //   paramName: "强制出风阀",
      //   paramValue: this.status.outManual ? 1 : 0,
      //   unit: "",
      //   inactiveValue: 0,
      //   activeValue: 1,
      //   remark: "0-自动，1-手动"
      // },{
      //   address: 2,
      //   bit: 9,
      //   type: 'bit',
      //   paramName: "强制止回阀",
      //   paramValue: this.status.backManual ? 1 : 0,
      //   unit: "",
      //   inactiveValue: 0,
      //   activeValue: 1,
      //   remark: "0-自动，1-手动"
      // },{
      //   address: 3,
      //   bit: 11,
      //   type: 'bit',
      //   paramName: "强制出风机1",
      //   paramValue: this.status.outFanManual1 ? 1 : 0,
      //   unit: "",
      //   inactiveValue: 0,
      //   activeValue: 1,
      //   remark: "0-关闭，1-启动"
      // },{
      //   address: 3,
      //   bit: 9,
      //   type: 'bit',
      //   paramName: "强制出风机2",
      //   paramValue: this.status.outFanManual2 ? 1 : 0,
      //   unit: "",
      //   inactiveValue: 0,
      //   activeValue: 1,
      //   remark: "0-关闭，1-启动"
      // },{
      //   address: 3,
      //   bit: 15,
      //   type: 'bit',
      //   paramName: "强制进风机1",
      //   paramValue: this.status.inFanManual1 ? 1 : 0,
      //   unit: "",
      //   inactiveValue: 0,
      //   activeValue: 1,
      //   remark: "0-关闭，1-启动"
      // },{
      //   address: 3,
      //   bit: 13,
      //   type: 'bit',
      //   paramName: "强制进风机2",
      //   paramValue: this.status.outFanManual2 ? 1 : 0,
      //   unit: "",
      //   inactiveValue: 0,
      //   activeValue: 1,
      //   remark: "0-关闭，1-启动"
      // },{
      //   address: 2,
      //   bit: 2,
      //   type: 'bit',
      //   paramName: "强制过滤器",
      //   paramValue: this.status.clothManual ? 1 : 0,
      //   unit: "",
      //   inactiveValue: 0,
      //   activeValue: 1,
      //   remark: "0-关闭，1-启动"
      // },{
      //   address: 2,
      //   bit: 11,
      //   type: 'bit',
      //   paramName: "强制空调运行",
      //   paramValue: this.status.acManual ? 1 : 0,
      //   unit: "",
      //   inactiveValue: 0,
      //   activeValue: 1,
      //   remark: "0-关闭，1-启动"
      // },{
      //   address: 137,
      //   type: 'float',
      //   paramName: "强制进风闸角度",
      //   paramValue: this.status.inAngleSet,
      //   unit: "%",
      //   min: 0,
      //   max: 100,
      //   remark: ""
      // },{
      //   address: 139,
      //   type: 'float',
      //   paramName: "强制混风闸角度",
      //   paramValue: this.status.mixedAngleSet,
      //   unit: "%",
      //   min: 0,
      //   max: 100,
      //   remark: ""
      },{
        address: 133,
        type: 'float',
        paramName: "进风机功率",
        paramValue: this.status.inPowerPercent,
        unit: "%",
        min: 0,
        max: 100,
        remark: ""
      }]
    })
  },
  methods: {
    close(){
      this.$emit("close");
    },
    /**
     * 设置单个参数；非管理员直接拒绝
     * @param {object} row 参数行（含 address/type/paramValue 等）
     */
    setParam(row){
      // 操作前再次校验权限，避免绕过入口直接调用
      if (!SessionStore.canSettingDeviceParams()) {
        this.$message.warning("仅系统管理员或单位管理员可配置设备参数");
        return;
      }
      this.loading = true;
      const codes = (this.deviceCode || "").split(",").map(s => (s || "").trim()).filter(Boolean);
      const reqs = codes.map(code => this.postForm("/modbus/setParam", {
        deviceCode: code,
        address: row.address,
        bit: row.bit || 0,
        type: row.type,
        value: row.paramValue
      }, true));
      Promise.all(reqs).finally(()=>{
        this.loading = false;
      });
    }
  }
}
</script>
<style lang="scss" scoped>
</style>